import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import InputGroupText from "./InputGroupText.vue";
import InputGroup from "./InputGroup.vue";

export type InputProps = {
  type?: string;
  hasError?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: /*@__PURE__*/_mergeModels({
    type: {},
    hasError: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean },
    value: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {



const hidden = ref(true);
const inputType = ref("password");

const emit = __emit;
const model = _useModel<string>(__props, "modelValue");

const handleChangeInputType = () => {
  hidden.value = !hidden.value;
  inputType.value = hidden.value ? "password" : "text";
};

return (_ctx: any,_cache: any) => {
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createBlock(InputGroup, { merge: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_Input, {
        placeholder: _ctx.placeholder,
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        type: inputType.value,
        hasError: _ctx.hasError
      }, null, 8, ["placeholder", "modelValue", "type", "hasError"]),
      _createVNode(InputGroupText, null, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            onClick: handleChangeInputType,
            class: _normalizeClass(["fa-regular cursor-pointer", { 'fa-eye': hidden.value, 'fa-eye-slash': !hidden.value }])
          }, null, 2)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})